import React from 'react';
import { Chip, Tooltip } from '@mui/material';
import VerifiedIcon from '@mui/icons-material/Verified';
import SmartToyOutlinedIcon from '@mui/icons-material/SmartToyOutlined';

// Public trust label on a listing:
//  - "claimed": the owner registered the listing, or took over an imported one by proving
//    they control the business's website email -> blue "verified by owner" badge.
//  - "auto": Cheesta listed it automatically from the business's public website and the
//    owner has not claimed it yet -> grey "auto listing" label.
// The API sends `ownershipBadge`; older responses only have claimStatus, so fall back to it.
export type OwnershipKind = 'claimed' | 'auto' | null;

export const ownershipOf = (b: { ownershipBadge?: string | null; claimStatus?: string | null }): OwnershipKind => {
    if (b.ownershipBadge === 'claimed' || b.ownershipBadge === 'auto') return b.ownershipBadge;
    if (b.claimStatus === 'verified') return 'claimed';
    if (b.claimStatus === 'unclaimed') return 'auto';
    return null;
};

const OwnershipBadge: React.FC<{ business: { ownershipBadge?: string | null; claimStatus?: string | null }; size?: 'card' | 'page' }> = ({ business, size = 'page' }) => {
    const kind = ownershipOf(business);
    if (!kind) return null;
    const small = size === 'card';
    const sx = { height: small ? 20 : 24, fontSize: small ? 11 : 12, fontWeight: 600, '& .MuiChip-icon': { fontSize: small ? 14 : 16 } };
    if (kind === 'claimed') {
        return (
            <Tooltip title="این آگهی توسط مالک کسب‌وکار ثبت یا تأیید شده است">
                <Chip size="small" icon={<VerifiedIcon />} label="تأییدشده توسط مالک"
                    sx={{ ...sx, bgcolor: '#1976d2', color: '#fff', '& .MuiChip-icon': { ...sx['& .MuiChip-icon'], color: '#fff' } }} />
            </Tooltip>
        );
    }
    return (
        <Tooltip title="اطلاعات این آگهی به‌صورت خودکار از وب‌سایت عمومی کسب‌وکار گردآوری شده و هنوز توسط مالک تأیید نشده است">
            <Chip size="small" icon={<SmartToyOutlinedIcon />} label="ثبت خودکار"
                sx={{ ...sx, bgcolor: 'rgba(255,255,255,0.9)', color: '#455a64', border: '1px solid #cfd8dc' }} />
        </Tooltip>
    );
};

export default OwnershipBadge;
